import { ChangeDocumentOptionDto, ChangeDto } from 'src/api/FiretrolApiClient';
import { changeApiClient } from 'src/api/FiretrolApiClientInstances';
import { createModuleQueries } from 'src/api/queries/workflowModules/createModuleQueries';
import { queryKeys } from 'src/api/queries/queryKeys';

const queries = createModuleQueries<ChangeDto, ChangeDocumentOptionDto>({
  label: 'change',
  listKey: queryKeys.changes.list,
  detailKey: queryKeys.changes.detail,
  documentOptionsKey: queryKeys.changes.documentOptions,
  list: (jobId, ct) => changeApiClient.getChangesByJob(jobId, ct),
  detail: (jobId, id, ct) => changeApiClient.getChangeById(jobId, id, ct),
  documentOptions: (jobId, ct) => changeApiClient.getDocumentOptions(jobId, ct),
});

/** @registry Changes for one job; shared by the Changes module and the job summary card. */
export const useChangesList = queries.useList;
export const useChange = queries.useDetail;
export const useChangeDocumentOptions = queries.useDocumentOptions;
